import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PageEvent } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-paginator',
  templateUrl: './fc-paginator.component.html',
  styleUrls: ['./fc-paginator.component.scss']
})
export class FcPaginatorComponent implements OnInit, OnChanges {

  @Input() public totalCount: number;
  @Input() public pageSize = 50;
  @Input() public pageIndex = 0;
  @Input() public currentPageLength = 0;
  @Input() public isLoading = false;
  @Output() public readonly page = new EventEmitter<PageEvent>();


  isFirstPage = false;
  isLastPage = false;
 from = 0;
  until = 0;

  constructor(private readonly fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    this.updateState();
  }

  ngOnChanges(_changes: SimpleChanges): void {
    this.updateState();
  }

  nextPage(): void {
    const previousPageIndex = this.pageIndex;
    this.pageIndex++;
    this.page.emit({
      length: this.totalCount,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      previousPageIndex: previousPageIndex
    });
    this.updateState();
  }

  previousPage(): void {
    const previousPageIndex = this.pageIndex;
    this.pageIndex--;
    this.page.emit({
      length: this.totalCount,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      previousPageIndex: previousPageIndex
    });
    this.updateState();
  }

  firstPage(): void {
    const previousPageIndex = this.pageIndex;
    this.pageIndex = 0;
    this.page.emit({
      length: this.totalCount,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      previousPageIndex: previousPageIndex
    });
    this.updateState();
  }

  private updateState(): void {
    this.isFirstPage = this.pageIndex <= 0;
    this.isLastPage = this.pageIndex + 1  >= Math.ceil(this.totalCount / this.pageSize) || this.currentPageLength < this.pageSize;
    this.from = this.pageIndex * this.pageSize + 1;
    this.until = this.isLastPage ? (this.from + this.currentPageLength - 1) : (this.pageIndex + 1) * this.pageSize;
  }
}
